/**
 * Styling hooks for ReStock's wishlist drawer (snippets/fd-wishlist-drawer.liquid). ReStock renders and owns the
 * drawer; this never changes the content of ReStock's own nodes:
 *
 * - `.nm-wishlist-drawer-count[data-fd-count]`: the number from ReStock's count label ("3 product(s)" -> "3"), which
 *   the CSS shows as the lime pill (the label itself is visually hidden).
 * - The trust badges (template#FdWishlistTrust) are appended to the item list when it has items; the CSS orders them
 *   after the items. ReStock drops the whole list (and the badges with it) when the last item goes.
 *
 * ReStock renders late and re-renders on every change, so one observer on body re-applies both, once per frame.
 */
(() => {
  const template = document.getElementById('FdWishlistTrust');
  const DIGITS = /[0-9٠-٩]+/;
  let queued = false;

  const update = () => {
    queued = false;
    for (const drawer of document.querySelectorAll('.nm-wishlist-drawer')) {
      const count = drawer.querySelector('.nm-wishlist-drawer-count');
      if (count instanceof HTMLElement) {
        const n = (count.textContent.match(DIGITS) || ['0'])[0];
        if (count.dataset.fdCount !== n) count.dataset.fdCount = n;
      }
      if (!(template instanceof HTMLTemplateElement)) continue;
      for (const list of drawer.querySelectorAll(':scope > div:not([class])')) {
        if (list.querySelector('.nm-wishlist-item-card') && !list.querySelector(':scope > .fd-wl-trust')) {
          list.append(template.content.cloneNode(true));
        }
      }
    }
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  schedule();
})();
